<app-content>
  <app-breadcrumbs>
    <li>
      <a href="/konsultacje-spoleczne">Partycypacje społeczne</a>
    </li>
    <li>
      {{ survey.title }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ survey.title }}
    </h2>
    @if (survey.userHasAnswered) {
      <app-alert [closable]="false" type="danger">
        Oddales już swój głos!
      </app-alert>
    }
    @if (form.questions.length) {
      <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <ng-container formArrayName="questions">
          @for (item of survey.surveyQuestions; track $index) {
            @if (form.getFormGroup($index); as formGroup) {
              <fieldset [formGroup]="formGroup">
                <legend>
                  {{ item.title }}
                </legend>
                @if (item?.type?.code === 'textarea') {
                  <div class="row">
                    <div class="col-12">
                      @if ("text"; as controlName) {
                        <div class='form-group'>
                          <label
                            [for]="item.uuid">Odpowiedź @if (formGroup.get(controlName)?.hasValidator(form.validators.required)) {
                            *
                          }</label>
                          <textarea
                            [ngClass]='{ "is-invalid": form.showControlError(formGroup.get(controlName)) }'
                            [id]="item.uuid"
                            rows='4'
                            [formControlName]='controlName'
                            autocomplete='off'
                            placeholder='Wpisz tu odpowiedź'
                            type='text'>
                          </textarea>
                          <app-validation-errors [control]='formGroup.get(controlName)'>
                          </app-validation-errors>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (item?.type?.code === 'checkbox') {
                  <br>
                  <div class="row" formArrayName="choices">
                    <div class="col-12">
                      <div class='form-group'>
                        @for (choice of item?.surveyQuestionChoices; track $index) {
                          <div class='custom-checkbox custom-block'
                               [ngClass]='{ "is-invalid": form.showControlError(formGroup.get(controlName)) }'
                               *ngIf='$index + "" as controlName'>
                            <input
                              #input
                              (change)="form.checkBoxChange(input?.checked ? $event : null, $index, formGroup)"
                              [value]='choice.uuid'
                              [formControlName]='controlName'
                              type='checkbox'
                              [id]='choice.uuid'
                              [name]='controlName'>
                            <label [for]='choice.uuid'>
                              {{ choice.title }}
                            </label>
                          </div>
                          <app-validation-errors [control]='form.get($index + "")'>
                          </app-validation-errors>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (item?.type?.code === 'radio') {
                  @if (form.questions.at($index).status === 'INVALID' && this.form.touched) {
                    <app-alert class="d-inline-block" alertTitle="Uwaga!" type="danger" [closable]="false">
                      Wymagane zaznaczenie minimum 1 pozycji.
                    </app-alert>
                  } @else {
                    <br>
                  }
                  <div class="row" formArrayName="choices">
                    <div class="col-12">
                      <div class="form-group">
                        @for (choice of item?.surveyQuestionChoices; track $index) {
                          <div class="custom-radio custom-block">
                            <input
                              [formControlName]='0 + ""'
                              [value]="choice.uuid"
                              type="radio"
                              [id]="choice.uuid">
                            <label [for]="choice.uuid">
                              {{ choice.title }}
                            </label>
                          </div>
                          <app-validation-errors [control]='form.get($index + "")'>
                          </app-validation-errors>
                        }
                      </div>
                    </div>
                  </div>
                }
              </fieldset>
            }
          }
        </ng-container>
        <div class="d-flex justify-content-end mt-5">
          <button
            routerLink="../"
            type='button'
            class='btn btn-secondary me-3'>
            <span>
              Wstecz
            </span>
          </button>
          @if (!survey.userHasAnswered) {
            <button
              [disabled]="pending()"
              type='submit'
              class='btn btn-primary'>
              <span>Wyślij</span>
            </button>
          }
        </div>
      </form>
    }
  </section>
</app-content>
